import { filledInputClasses, inputBaseClasses, inputLabelClasses } from '@mui/material';
import type { Components, Theme } from '@mui/material/styles';

export const MuiTextField: Components<Omit<Theme, 'components'>>['MuiTextField'] = {
  defaultProps: {
    variant: 'filled',
    hiddenLabel: true,
    slotProps: {
      inputLabel: { shrink: true },
      htmlInput: {
        onWheel: (event: React.WheelEvent<HTMLInputElement>) => {
          const target = event.target as HTMLInputElement;
          if (target.type === 'number') {
            target.blur();
          }
        },
      },
    },
    size: 'medium',
  },
  variants: [
    {
      props: { size: 'small' },
      style: {
        [`& .${filledInputClasses.root}`]: {
          height: '32px',
        },
      },
    },
  ],
  styleOverrides: {
    root: ({ ownerState }) => ({
      [`& .${filledInputClasses.root}`]: {
        paddingLeft: '12px',
        [`&.${inputBaseClasses.root}`]: {
          marginTop: 'auto',
          backgroundColor: '#F5F6FA',
        },
        [`& .${inputBaseClasses.input}`]: {
          padding: ownerState.size === 'medium' ? '12px' : '',
        },
      },
      [`& .${inputLabelClasses.filled}`]: {
        transform: 'unset',
        fontSize: '12px',
        position: 'unset',
        marginBottom: '8px',
      },
    }),
  },
};
